import { useMutation } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const useSaveDefenseCounselsMutation = () => {
    const { zoneApiClient } = useZoneContext();

    return useMutation({
        mutationFn: async (data: { caseGuid: string; defenseCounselGuids: string[] }) => {
            const response = await zoneApiClient.saveCaseFileZoneDefenseCounsels(
                data.caseGuid,
                data.defenseCounselGuids
            );

            if (!response?.httpResponse.ok) {
                throw new Error('Failed to save defense counsel');
            }
            return response.payload;
        },
    });
};
